import { render, staticRenderFns } from "./ExpedienteLocal.vue?vue&type=template&id=1f77a0a5&"
import script from "./ExpedienteLocal.vue?vue&type=script&lang=js&"
export * from "./ExpedienteLocal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports